import _ from 'underscore';

export default class CampaignAssociationsRequestFactory {
  setEntityIds(options, scope) {
    options.entitySet = options.entitySet.Campaigns.$withKey(scope.campaignId);
  }

  generateDestroyRequest(ids, scope) {
    return [{
      'adExtensionAssociations': this.getBatchRequest(ids, scope),
    }];
  }

  generateUpdateRequest(ids, scopes) {
    return [{
      'adExtensionAssociations': _.chain(scopes)
        .map((scope) => this.getBatchRequest(ids, scope))
        .flatten(true)
        .value(),
    }];
  }

  getBatchRequest(idList, scope) {
    return _.map(idList, (id) => ({
      Type: 'Campaign',
      CampaignId: scope.campaignId,
      AdGroupId: scope.adGroupId,
      AdExtensionId: id,
    }));
  }
}
